export default function LoveIcon({ color = "#6C757D" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M8.91041 3.83522L9 3.92731L9.08959 3.83522L9.80635 3.0985C11.4248 1.43494 14.4094 2.00268 15.4884 4.10981C15.991 5.09149 16.1148 6.52551 15.1742 8.38106C14.2729 10.1592 12.3975 12.3007 9 14.6429C5.60253 12.3007 3.72709 10.1592 2.82579 8.38106C1.88523 6.52551 2.00895 5.09149 2.51162 4.10981C3.59058 2.00268 6.57518 1.43494 8.19365 3.0985L8.91041 3.83522ZM8.93109 16.1043L9 16.1498L9.06891 16.1043C12.9123 13.5647 15.1427 11.1563 16.2463 9.0298C17.3514 6.90045 17.3272 5.05099 16.6551 3.64917C15.3179 0.860262 11.4317 -0.103369 9.09102 2.05112C9.06041 2.0793 9.03006 2.10801 9 2.13725C8.96993 2.10801 8.93959 2.07929 8.90897 2.05111C6.56828 -0.103368 2.68213 0.860267 1.34494 3.64917C0.672803 5.051 0.648607 6.90045 1.75372 9.02981C2.85735 11.1563 5.08768 13.5647 8.93109 16.1043Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
    </svg>
  );
}
